import { useMemo } from "react"

import { useMissionsQuery } from "../../networking/missions/queries"
import { MissionStatus } from "../../types"

const useGetStarted = () => {
  const { data: missions } = useMissionsQuery()

  const completeMissions = useMemo(
    () =>
      missions?.filter(
        (mission) => mission.status.status === MissionStatus.REDEEMED
      ),
    [missions]
  )
  const incompleteMissions = useMemo(
    () =>
      missions?.filter(
        (mission) => mission.status.status === MissionStatus.INCOMPLETE
      ),
    [missions]
  )
  const hasCompletedAllMissions =
    missions?.length && (!incompleteMissions || incompleteMissions.length === 0)

  return { completeMissions, incompleteMissions, hasCompletedAllMissions }
}

export default useGetStarted
